// based on https://github.sc-corp.net/Snapchat/snapchat/blob/master/
// libs/ad-stats-schema/src/main/proto/country_type.proto
export const countryFullNameMap: Record<string, string> = {
    COUNTRY_AC: "Ascension",
    COUNTRY_AD: "Andorra",
    COUNTRY_AE: "United Arab Emirates",
    COUNTRY_AF: "Afghanistan",
    COUNTRY_AG: "Antigua And Barbuda",
    COUNTRY_AI: "Anguilla",
    COUNTRY_AL: "Albania",
    COUNTRY_AM: "Armenia",
    COUNTRY_AN: "Netherlands Antilles",
    COUNTRY_AO: "Angola",
    COUNTRY_AQ: "Antarctica",
    COUNTRY_AR: "Argentina",
    COUNTRY_AS: "American Samoa",
    COUNTRY_AT: "Austria",
    COUNTRY_AU: "Australia",
    COUNTRY_AW: "Aruba",
    COUNTRY_AX: "Aland",
    COUNTRY_AZ: "Azerbaijan",
    COUNTRY_BA: "Bosnia And Herzegovina",
    COUNTRY_BB: "Barbados",
    COUNTRY_BD: "Bangladesh",
    COUNTRY_BE: "Belgium",
    COUNTRY_BF: "Burkina Faso",
    COUNTRY_BG: "Bulgaria",
    COUNTRY_BH: "Bahrain",
    COUNTRY_BI: "Burundi",
    COUNTRY_BJ: "Benin",
    COUNTRY_BL: "Saint Barthelemy",
    COUNTRY_BM: "Bermuda",
    COUNTRY_BN: "Brunei",
    COUNTRY_BO: "Bolivia",
    COUNTRY_BQ: "Bonaire, Saint Eustatius and Saba",
    COUNTRY_BR: "Brazil",
    COUNTRY_BS: "Bahamas",
    COUNTRY_BT: "Bhutan",
    COUNTRY_BV: "Bouvet Island",
    COUNTRY_BW: "Botswana",
    COUNTRY_BY: "Belarus",
    COUNTRY_BZ: "Belize",
    COUNTRY_CA: "Canada",
    COUNTRY_CC: "Cocos Islands",
    COUNTRY_CD: "Congo Kinshasa",
    COUNTRY_CF: "Central African Republic",
    COUNTRY_CG: "Congo Brazzaville",
    COUNTRY_CH: "Switzerland",
    COUNTRY_CI: "Cote D Ivoire",
    COUNTRY_CK: "Cook Islands",
    COUNTRY_CL: "Chile",
    COUNTRY_CM: "Cameroon",
    COUNTRY_CN: "China",
    COUNTRY_CO: "Colombia",
    COUNTRY_CR: "Costa Rica",
    COUNTRY_CU: "Cuba",
    COUNTRY_CV: "Cape Verde",
    COUNTRY_CW: "Curacao",
    COUNTRY_CX: "Christmas Island",
    COUNTRY_CY: "Cyprus",
    COUNTRY_CZ: "Czech Republic",
    COUNTRY_DE: "Germany",
    COUNTRY_DJ: "Djibouti",
    COUNTRY_DK: "Denmark",
    COUNTRY_DM: "Dominica",
    COUNTRY_DO: "Dominican Republic",
    COUNTRY_DZ: "Algeria",
    COUNTRY_EC: "Ecuador",
    COUNTRY_EE: "Estonia",
    COUNTRY_EG: "Egypt",
    COUNTRY_EH: "Western Sahara",
    COUNTRY_ER: "Eritrea",
    COUNTRY_ES: "Spain",
    COUNTRY_ET: "Ethiopia",
    COUNTRY_EU: "European Union",
    COUNTRY_FI: "Finland",
    COUNTRY_FJ: "Fiji",
    COUNTRY_FK: "Falkland Islands",
    COUNTRY_FM: "Micronesia",
    COUNTRY_FO: "Faroe Islands",
    COUNTRY_FR: "France",
    COUNTRY_GA: "Gabon",
    COUNTRY_GB: "United Kingdom",
    COUNTRY_GD: "Grenada",
    COUNTRY_GE: "Georgia",
    COUNTRY_GF: "French Guiana",
    COUNTRY_GG: "Guernsey",
    COUNTRY_GH: "Ghana",
    COUNTRY_GI: "Gibraltar",
    COUNTRY_GL: "Greenland",
    COUNTRY_GM: "Gambia",
    COUNTRY_GN: "Guinea",
    COUNTRY_GP: "Guadeloupe",
    COUNTRY_GQ: "Equatorial Guinea",
    COUNTRY_GR: "Greece",
    COUNTRY_GS: "South Georgia And South Sandwich Islands",
    COUNTRY_GT: "Guatemala",
    COUNTRY_GU: "Guam",
    COUNTRY_GW: "Guinea Bissau",
    COUNTRY_GY: "Guyana",
    COUNTRY_HK: "Hong Kong",
    COUNTRY_HM: "Heard Island And Mcdonald Islands",
    COUNTRY_HN: "Honduras",
    COUNTRY_HR: "Croatia",
    COUNTRY_HT: "Haiti",
    COUNTRY_HU: "Hungary",
    COUNTRY_ID: "Indonesia",
    COUNTRY_IE: "Ireland",
    COUNTRY_IL: "Israel",
    COUNTRY_IM: "Isle Of Man",
    COUNTRY_IN: "India",
    COUNTRY_IO: "British Indian Ocean Territory",
    COUNTRY_IQ: "Iraq",
    COUNTRY_IR: "Iran",
    COUNTRY_IS: "Iceland",
    COUNTRY_IT: "Italy",
    COUNTRY_JE: "Jersey",
    COUNTRY_JM: "Jamaica",
    COUNTRY_JO: "Jordan",
    COUNTRY_JP: "Japan",
    COUNTRY_KE: "Kenya",
    COUNTRY_KG: "Kyrgyzstan",
    COUNTRY_KH: "Cambodia",
    COUNTRY_KI: "Kiribati",
    COUNTRY_KM: "Comoros",
    COUNTRY_KN: "Saint Kitts And Nevis",
    COUNTRY_KP: "North Korea",
    COUNTRY_KR: "South Korea",
    COUNTRY_KW: "Kuwait",
    COUNTRY_KY: "Cayman Islands",
    COUNTRY_KZ: "Kazakhstan",
    COUNTRY_LA: "Laos",
    COUNTRY_LB: "Lebanon",
    COUNTRY_LC: "Saint Lucia",
    COUNTRY_LI: "Liechtenstein",
    COUNTRY_LK: "Sri Lanka",
    COUNTRY_LR: "Liberia",
    COUNTRY_LS: "Lesotho",
    COUNTRY_LT: "Lithuania",
    COUNTRY_LU: "Luxembourg",
    COUNTRY_LV: "Latvia",
    COUNTRY_LY: "Libya",
    COUNTRY_MA: "Morocco",
    COUNTRY_MC: "Monaco",
    COUNTRY_MD: "Moldova",
    COUNTRY_ME: "Montenegro",
    COUNTRY_MF: "Saint Martin",
    COUNTRY_MG: "Madagascar",
    COUNTRY_MH: "Marshall Islands",
    COUNTRY_MK: "Macedonia",
    COUNTRY_ML: "Mali",
    COUNTRY_MM: "Myanmar Burma",
    COUNTRY_MN: "Mongolia",
    COUNTRY_MO: "Macau",
    COUNTRY_MP: "Northern Mariana Islands",
    COUNTRY_MQ: "Martinique",
    COUNTRY_MR: "Mauritania",
    COUNTRY_MS: "Montserrat",
    COUNTRY_MT: "Malta",
    COUNTRY_MU: "Mauritius",
    COUNTRY_MV: "Maldives",
    COUNTRY_MW: "Malawi",
    COUNTRY_MX: "Mexico",
    COUNTRY_MY: "Malaysia",
    COUNTRY_MZ: "Mozambique",
    COUNTRY_NA: "Namibia",
    COUNTRY_NC: "New Caledonia",
    COUNTRY_NE: "Niger",
    COUNTRY_NF: "Norfolk Island",
    COUNTRY_NG: "Nigeria",
    COUNTRY_NI: "Nicaragua",
    COUNTRY_NL: "Netherlands",
    COUNTRY_NO: "Norway",
    COUNTRY_NP: "Nepal",
    COUNTRY_NR: "Nauru",
    COUNTRY_NU: "Niue",
    COUNTRY_NZ: "New Zealand",
    COUNTRY_OM: "Oman",
    COUNTRY_PA: "Panama",
    COUNTRY_PE: "Peru",
    COUNTRY_PF: "French Polynesia",
    COUNTRY_PG: "Papua New Guinea",
    COUNTRY_PH: "Philippines",
    COUNTRY_PK: "Pakistan",
    COUNTRY_PL: "Poland",
    COUNTRY_PM: "Saint Pierre And Miquelon",
    COUNTRY_PN: "Pitcairn Islands",
    COUNTRY_PR: "Puerto Rico",
    COUNTRY_PS: "Palestine",
    COUNTRY_PT: "Portugal",
    COUNTRY_PW: "Palau",
    COUNTRY_PY: "Paraguay",
    COUNTRY_QA: "Qatar",
    COUNTRY_RE: "Reunion",
    COUNTRY_RO: "Romania",
    COUNTRY_RS: "Serbia",
    COUNTRY_RU: "Russia",
    COUNTRY_RW: "Rwanda",
    COUNTRY_SA: "Saudi Arabia",
    COUNTRY_SB: "Solomon Islands",
    COUNTRY_SC: "Seychelles",
    COUNTRY_SD: "Sudan",
    COUNTRY_SE: "Sweden",
    COUNTRY_SG: "Singapore",
    COUNTRY_SH: "Saint Helena",
    COUNTRY_SI: "Slovenia",
    COUNTRY_SJ: "Svalbard",
    COUNTRY_SK: "Slovakia",
    COUNTRY_SL: "Sierra Leone",
    COUNTRY_SM: "San Marino",
    COUNTRY_SN: "Senegal",
    COUNTRY_SO: "Somalia",
    COUNTRY_SR: "Suriname",
    COUNTRY_SS: "South Sudan",
    COUNTRY_ST: "Sao Tome And Principe",
    COUNTRY_SV: "El Salvador",
    COUNTRY_SX: "Sint Marteen",
    COUNTRY_SY: "Syria",
    COUNTRY_SZ: "Swaziland",
    COUNTRY_TA: "Tristan Da Cunha",
    COUNTRY_TC: "Turks And Caicos Islands",
    COUNTRY_TD: "Chad",
    COUNTRY_TF: "French Southern And Antarctic Lands",
    COUNTRY_TG: "Togo",
    COUNTRY_TH: "Thailand",
    COUNTRY_TJ: "Tajikistan",
    COUNTRY_TK: "Tokelau",
    COUNTRY_TL: "Timor Leste",
    COUNTRY_TM: "Turkmenistan",
    COUNTRY_TN: "Tunisia",
    COUNTRY_TO: "Tonga",
    COUNTRY_TR: "Turkey",
    COUNTRY_TT: "Trinidad And Tobago",
    COUNTRY_TV: "Tuvalu",
    COUNTRY_TW: "Taiwan",
    COUNTRY_TZ: "Tanzania",
    COUNTRY_UA: "Ukraine",
    COUNTRY_UG: "Uganda",
    COUNTRY_UK: "United Kingdom",
    COUNTRY_UM: "Minor Outlying Islands",
    COUNTRY_US: "United States",
    COUNTRY_UY: "Uruguay",
    COUNTRY_UZ: "Uzbekistan",
    COUNTRY_VA: "Vatican City",
    COUNTRY_VC: "Saint Vincent And The Grenadines",
    COUNTRY_VE: "Venezuela",
    COUNTRY_VG: "British Virgin Islands",
    COUNTRY_VI: "Us Virgin Islands",
    COUNTRY_VN: "Vietnam",
    COUNTRY_VU: "Vanuatu",
    COUNTRY_WF: "Wallis And Futuna",
    COUNTRY_WS: "Samoa",
    COUNTRY_YE: "Yemen",
    COUNTRY_YT: "Mayotte",
    COUNTRY_ZA: "South Africa",
    COUNTRY_ZM: "Zambia",
    COUNTRY_ZW: "Zimbabwe",
    COUNTRY_ZZ: "Unknown",
};
